export default function ProjectDescriptions(props) {
    return (
        <div
            className='w-full mb-6 text-center flex flex-wrap lg:flex-nowrap items-center divGradient rounded-2xl lg:space-x-6 p-6 space-y-6'>
            <div
                className='xl:w-2/3 w-full flex flex-wrap justify-start text-start'>
                <div>
                    <h2 className='font-bold xl:text-2xl'>{ props.title }</h2>
                    <span className='text-yellow-200 xl:text-xl'>{ props.technologies }</span>
                </div>
                <span className='xl:text-xl'>
                    { props.description }
                </span>
            </div>
            <div className='rounded-xl h-48 w-full sm:h-full mb-4 lg:mb-0 lg:w-1/3'>
                {
                    props.video ?
                        <video className='h-64 sm:w-120 rounded-2xl'
                               src={props.video}
                               type="video/mp4"
                               poster={props.picture}
                               controls/>
                        : <img className='h-64 sm:w-120 rounded-2xl' src={props.picture} alt=''/>
                }
            </div>
        </div>
    );
}